module.exports = __webpack_public_path__ + "static/images/nophoto.7c5c663.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nophoto.jpg
// module id = 297
// module chunks = 2